import React from "react";
import PropTypes from "prop-types";
import { CardBody, TvCard, TvDiv, TvH4, TvSmall, TvP } from "@trustvid/design-system";
import AuthBodyCanvas from "./AuthBodyCanvas";
import LoginPageLayout from "./LoginPageLayout";
import { AUTH_FEATURE_PANEL_HEADING, AUTH_PAGE_COPY } from "./loginPageContent";
import { trustvidWordmark } from "./authBranding";

export { useAuthPageBodyLock } from "./useAuthPageBodyLock";
export { default as AuthPageFooter } from "./AuthPageFooter";

export const AuthFormBrand = ({ testId = "auth-platform-brand", className }) => (
  <TvDiv
    className={className || "tv-login-page__brand d-flex align-items-center justify-content-center gap-3 mb-4"}
    data-testid={testId}
  >
    <TvDiv className="tv-login-page__wordmark-frame">
      <img src={trustvidWordmark} alt={AUTH_PAGE_COPY.platformName} className="tv-login-page__wordmark" />
    </TvDiv>
  </TvDiv>
);

AuthFormBrand.propTypes = {
  testId: PropTypes.string,
  className: PropTypes.string,
};

const AuthSplitLayout = ({
  pageTestId,
  cardTestId,
  cardTitleTestId = "auth-card-title",
  brandTestId = "auth-platform-brand",
  showCardHeading = true,
  cardTitle,
  cardSubtitle,
  welcomeHeading,
  welcomeHeadingTestId = "auth-welcome-heading",
  featurePanelHeading,
  children,
}) => {
  const leftPanelHeading = featurePanelHeading ?? AUTH_FEATURE_PANEL_HEADING;

  return (
    <LoginPageLayout
      pageTestId={pageTestId}
      pageHeading={leftPanelHeading}
      bodyCanvas={<AuthBodyCanvas />}
      hideFormBrandOnMobile
      formColumnClassName="tv-login-page__form-column tv-login-page__form-column--split position-relative d-flex flex-column"
    >
      <TvDiv className="tv-login-page__card-wrap tv-login-page__card-wrap--hero w-100">
        <TvCard
          className="tv-login-page__card tv-login-page__card--panel border-0 position-relative"
          data-testid={cardTestId}
        >
          <CardBody className="tv-login-page__card-body">
            {showCardHeading ? (
              <TvDiv className="tv-login-page__card-top mb-2" data-testid={cardTitleTestId}>
                <TvSmall className="tv-login-page__card-heading mb-0 fw-semibold text-uppercase">
                  {cardTitle}
                </TvSmall>
              </TvDiv>
            ) : null}

            <AuthFormBrand
              testId={brandTestId}
              className="tv-login-page__brand d-flex align-items-center justify-content-center gap-3 mb-4"
            />

            {welcomeHeading ? (
              <TvDiv className="tv-login-page__card-top mb-2" data-testid={welcomeHeadingTestId}>
                <TvH4 className="tv-login-page__card-heading fw-bold text-dark mb-1">{welcomeHeading}</TvH4>
              </TvDiv>
            ) : null}

            {cardSubtitle ? (
              <TvP className="tv-login-page__card-subtitle text-muted small mb-3 mb-lg-4">{cardSubtitle}</TvP>
            ) : null}

            <TvDiv className="tv-login-page__card-form tv-login-page__form-stack">{children}</TvDiv>
          </CardBody>
        </TvCard>
      </TvDiv>
    </LoginPageLayout>
  );
};

AuthSplitLayout.propTypes = {
  pageTestId: PropTypes.string.isRequired,
  cardTestId: PropTypes.string.isRequired,
  cardTitleTestId: PropTypes.string,
  brandTestId: PropTypes.string,
  showCardHeading: PropTypes.bool,
  cardTitle: PropTypes.string.isRequired,
  cardSubtitle: PropTypes.string,
  welcomeHeading: PropTypes.string,
  welcomeHeadingTestId: PropTypes.string,
  featurePanelHeading: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default AuthSplitLayout;
